const groupCmatchesReducer = (state = [], action) => {
  switch (action.type) {
    case "SET_GROUP_C_MATCHES":
      return action.payload;
    case "UNSET_GROUP_C_MATCHES":
      return {};
    default:
      return state;
  }
};

// user will be on the redux state at:
// state.user
export default groupCmatchesReducer;
